import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[abUnits]'
})
export class UnitsDirective implements OnInit {
  @Input('abUnits') value: string;

  constructor(private element: ElementRef) {}

  ngOnInit() {
    this.element.nativeElement.innerText = `${this.convertToKiloByte(
      parseFloat(this.value)
    )} `;
  }

  private convertToKiloByte(byte: number) {
    if (isNaN(byte)) {
      return '';
    }

    const kiloByte = byte / 1000;

    return kiloByte === 0 ? kiloByte : kiloByte.toFixed(1);
  }
}
